import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getLoggedUserId } from "~/store/selectors/selector.users";

export const NotAuthenticated = ({ children, redirectTo }) => {
  const loggedUserId = useSelector(getLoggedUserId);
  return loggedUserId > 0 ? <Navigate to={redirectTo} /> : children;
};

NotAuthenticated.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

NotAuthenticated.defaultProps = {
  redirectTo: "/",
};
